module.exports = __webpack_public_path__ + "img/logo-copy.0f7f73c9.svg";